import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

export default function TermsPopup({ terms, open, handleClose, title }) {
  return (
    <Dialog open={open} onClose={handleClose} scroll={'paper'}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Box
          dangerouslySetInnerHTML={{
            __html: terms.replace(/\n/g, '<br/>'),
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>關閉</Button>
      </DialogActions>
    </Dialog>
  );
}
